// Where each page stands in the writing: a short, writer-defined list of
// stages (Idea → Final by default). A page stores only the id of its status,
// so renaming or recoloring a status updates every page that carries it;
// a page whose status has been deleted simply shows none.

export interface PageStatus {
  id: string
  label: string
  /** #rrggbb */
  color: string
}

export const DEFAULT_PAGE_STATUSES: PageStatus[] = [
  { id: 'idea', label: 'Idea', color: '#9b8f78' },
  { id: 'drafting', label: 'Drafting', color: '#d98a3a' },
  { id: 'drafted', label: 'Drafted', color: '#1f7a72' },
  { id: 'revising', label: 'Revising', color: '#8a64c0' },
  { id: 'final', label: 'Final', color: '#3f8f4f' },
]

export const MAX_PAGE_STATUSES = 12
export const MAX_SYNOPSIS_LENGTH = 600
const STATUS_ID_RE = /^[a-z0-9_-]{1,40}$/i

export function normalizeStatusId(raw: unknown): string | undefined {
  return typeof raw === 'string' && STATUS_ID_RE.test(raw) ? raw : undefined
}

export function normalizeSynopsis(raw: unknown): string | undefined {
  if (typeof raw !== 'string') return undefined
  const text = raw.replace(/\r\n?/g, '\n').replace(/\n{3,}/g, '\n\n').trim().slice(0, MAX_SYNOPSIS_LENGTH)
  return text || undefined
}

export function normalizePageStatuses(raw: unknown): PageStatus[] {
  if (!Array.isArray(raw)) return DEFAULT_PAGE_STATUSES.map((status) => ({ ...status }))
  const seen = new Set<string>()
  const statuses: PageStatus[] = []
  for (const item of raw) {
    const id = normalizeStatusId(item?.id)
    if (!id || seen.has(id)) continue
    seen.add(id)
    statuses.push({
      id,
      label: typeof item.label === 'string' && item.label.trim() ? item.label.trim().slice(0, 24) : 'Status',
      color: typeof item.color === 'string' && /^#[0-9a-f]{6}$/i.test(item.color) ? item.color : '#9b8f78',
    })
    if (statuses.length >= MAX_PAGE_STATUSES) break
  }
  return statuses
}

export function newStatusId(): string {
  return `status-${Date.now().toString(36)}${Math.random().toString(36).slice(2, 6)}`
}
